import { Column, Table } from '@tanstack/react-table';
import ColumnFilterSearch from './ColumnFilterSearch';
import ColumnFilterSelect from './ColumnFilterSelect';

const Filter = ({
  column,
  filterValue = '',
  filter = null,
}: {
  column: Column<any, unknown>;
  filterValue: any;
  filter: any;
}) => {

  const { type: filterType = 'search', data: filterData } = filter || {};

  return (
    <>
      {filterType === 'search' &&
        <ColumnFilterSearch
          column={column}
          filterValue={filterValue}
        />
      }
      {filterType === 'select' &&
        <ColumnFilterSelect
          column={column}
          filterValue={filterValue}
          filterData={filterData}
        />
      }
    </>
  );
};

export default Filter;